var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "-0.5 -0.15 22 19",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.989 4.706H.983C.44 4.706 0 4.31 0 3.824V2.059c0-.487.44-.883.983-.883H19.99c.543 0 .983.396.983.883v1.765c0 .487-.44.882-.983.882zm-.328 12.059v-10c0-.488-.44-.883-.983-.883H2.294c-.543 0-.983.395-.983.883v10c0 .487.44.882.983.882h16.384c.543 0 .983-.395.983-.882zm-7.045-7.353h-4.26c-.271 0-.492-.198-.492-.441v-.294c0-.244.22-.442.492-.442h4.26c.271 0 .491.198.491.442v.294c0 .243-.22.44-.491.44z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.cb2f9ea6fd390c05a4f154b3854c48f1.svg";
export { ForwardRef as ReactComponent };